var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Column',{staticClass:"menu-item",attrs:{"fill":_vm.spacer,"below-nav-width":100,"middle":""}},[(!_vm.spacer)?_c('router-link',{attrs:{"to":_vm.url}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }